import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Protected from "../views/Protected.vue";
import Countries from "../views/Countries.vue";
import Profiles from "../views/Profiles.vue";
import FunctionalitiesProfiles from "../views/FunctionalitiesProfiles.vue";
import Agencies from "../views/Agencies.vue";
import Routes from "../views/Routes.vue";
import Zones from "../views/Zones.vue";
import PostalCodes from "../views/PostalCodes.vue";
import Holidays from "../views/Holidays.vue";
import Services from "../views/Services.vue";
import ProductsTypes from "../views/ProductsTypes.vue";
import ProductsTypesOperations from "../views/ProductsTypesOperations.vue";
import AgencyParameters from "../views/AgencyParameters.vue";
import Clients from "../views/Clients.vue";
import TimeSlotsClients from "../views/TimeSlotsClients.vue";
import TimeSlots from "../views/TimeSlots.vue";
import Users from "../views/Users.vue";
import Statistics from "../views/Statistics.vue";
import Audit from "../views/Audit.vue";
import TimeSlotsReservations from "../views/TimeSlotsReservations.vue";
import { DEFAULT_APPLICATION_ROLE } from "../plugins/keycloak.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { isAuthenticated: true }
  },
  {
    path: "/protected",
    name: "protected",
    component: Protected,
    meta: { isAuthenticated: true }
  },
  {
    path: "/countries",
    name: "countries",
    component: Countries,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "COUNTRIES"
    }
  },
  {
    path: "/agencies",
    name: "agencies",
    component: Agencies,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "AGENCIES"
    }
  },
  {
    path: "/routes",
    name: "routes",
    component: Routes,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "ROUTES"
    }
  },
  {
    path: "/zones",
    name: "zones",
    component: Zones,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "ZONES"
    }
  },
  {
    path: "/postalCodes",
    name: "postalCodes",
    component: PostalCodes,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "POSTALCODES"
    }
  },
  {
    path: "/holidays",
    name: "holidays",
    component: Holidays,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "HOLIDAYS"
    }
  },
  {
    path: "/services",
    name: "services",
    component: Services,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "SERVICES"
    }
  },
  {
    path: "/agencyParameters",
    name: "agencyParameters",
    component: AgencyParameters,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "AGENCYPARAMETERS"
    }
  },
  {
    path: "/clients",
    name: "clients",
    component: Clients,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "CLIENTS"
    }
  },
  {
    path: "/profiles",
    name: "profiles",
    component: Profiles,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "PROFILES"
    }
  },
  {
    path: "/functionalitiesProfiles",
    name: "functionalitiesProfiles",
    component: FunctionalitiesProfiles,
    props: route => ({
      profile: route.query.profile
    }),
    meta: {
      isAuthenticated: true,
      functionalityPermission: "PROFILES"
    }
  },
  {
    path: "/productsTypes",
    name: "productsTypes",
    component: ProductsTypes,
    meta: { isAuthenticated: true, functionalityPermission: "PRODUCTSTYPES" }
  },
  {
    path: "/productsTypesOperations",
    name: "productsTypesOperations",
    component: ProductsTypesOperations,
    props: route => ({
      productType: route.query.productType
    }),
    meta: { isAuthenticated: true, functionalityPermission: "PRODUCTSTYPES" }
  },
  {
    path: "/timeSlotsClients",
    name: "timeSlotsClients",
    component: TimeSlotsClients,
    props: route => ({
      client: route.query.client
    }),
    meta: {
      isAuthenticated: true,
      functionalityPermission: "TIMESLOTSCLIENTS"
    }
  },
  {
    path: "/timeSlots",
    name: "timeSlots",
    component: TimeSlots,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "TIMESLOTS"
    }
  },
  {
    path: "/users",
    name: "users",
    component: Users,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "USERS"
    }
  },
  {
    path: "/statistics",
    name: "statistics",
    component: Statistics,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "TIMESLOTS"
    }
  },
  {
    path: "/audit",
    name: "audit",
    component: Audit,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "AUDIT"
    }
  },
  {
    path: "/timeSlotsReservations",
    name: "timeSlotsReservations",
    component: TimeSlotsReservations,
    meta: {
      isAuthenticated: true,
      functionalityPermission: "TIMESLOTSRESERVATIONS"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.isAuthenticated) {
    // Get the actual url of the app, it's needed for Keycloak
    const basePath = window.location.toString();
    if (!Vue.$keycloak.authenticated) {
      // The page is protected and the user is not authenticated. Force a login.
      Vue.$keycloak.login({ redirectUri: basePath + to.path });
    } else if (Vue.$keycloak.hasResourceRole(DEFAULT_APPLICATION_ROLE)) {
      // The user was authenticated, and has the app role (is authorized). Update the token.
      Vue.$keycloak
        .updateToken(40)
        .then(() => {
          if (
            to.meta.functionalityPermission &&
            !router.app.$checkFunctionality(to.meta.functionalityPermission)
          ) {
            next({ name: "home" });
          } else {
            next();
          }
        })
        .catch(err => {
          console.error(err);
        });
    } else {
      // The user was authenticated, but did not have the correct role (is not authorized)
      // Redirect the user to an error page
      Vue.$keycloak.logout();
    }
  } else {
    // This page did not require authentication
    next();
  }
});

export default router;
